import APIService from './APIService';

export default {
  listar() {
    return APIService.apiCall().get('/validacoes-bdgds-modelos/listar');
  },
  obter(id) {
    return APIService.apiCall().get(`/validacoes-bdgds-modelos/obter/${id}`);
  },
  salvar(dados) {
    return APIService.apiCall().post('/validacoes-bdgds-modelos/salvar', JSON.stringify(dados));
  },
  testar(codigoSql, entidades) {
    return APIService.apiCall().post('/validacoes-bdgds-modelos/testar', JSON.stringify({ codigo_sql: codigoSql, entidades }));
  }
};
